import styled from 'styled-components';

const LinkImage = styled.img`
  width: 100%;
  height: auto;
`;

export default LinkImage;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HeroImage/TextBlock/LinkImage.jsx